<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/home_page/faultType/homeFaultType' }">{{formInline.faultName}}
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/home_page/faultType/homeFaultCarType' }">{{formInline.faultDetails}}
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{formInline.carTypeName}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="operation_list">
            <div style="float:right;margin-bottom: 20px;margin-right: 20px;">
                <el-button size="small" type="primary" icon="el-icon-download" @click="exportFaultCar()">导出</el-button>
            </div>
            <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
                <el-table-column align="center" prop="vin" min-width="200" label="编号">
                </el-table-column>
                <el-table-column align="center" prop="value" min-width="200" label="次数">
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>

<script>
import { fault_vin_by_equipment_details_type, get_export_fault_vin_by_equipment_details_type } from "../../../api/index/index"
import Pagination from "../../../components/Pagination";
export default {
    data() {
        return {
            formInline: {
                faultName: window.localStorage.getItem("faultName"),
                faultDetails: window.localStorage.getItem("faultDetails"),
                carTypeId: window.localStorage.getItem("carTypeId"),
                carTypeName:window.localStorage.getItem("carTypeName"),
                faultStartTime: window.localStorage.getItem("fault_start_time"),
                faultEndTime: window.localStorage.getItem("fault_end_time"),
                page: 1,
                limit: 10,
            },
            listData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10,
            },
        }
    },
    //页面加载
    created() {
        this.getData()
    },
    components: {
        Pagination,
    },
    methods: {
        getData() {
            fault_vin_by_equipment_details_type(this.formInline).then((res) => {
                if (res["code"] === 0) {
                    this.listData = res.data
                    this.pageparm.currentPage = this.formInline.page;
                    this.pageparm.pageSize = this.formInline.limit;
                    this.pageparm.total = res.total
                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage;
            this.formInline.limit = parm.pageSize;
            this.getData();
        },
        exportFaultCar() {
            get_export_fault_vin_by_equipment_details_type(this.formInline)
                .then((res) => {
                    if (res["code"] == undefined) {
                        // 这里根据后端返回使用res或res.data
                        var blob = new Blob([res], {
                            type: "application/ms-excel",
                        });
                        var elink = document.createElement("a");
                        elink.download = this.formInline.carTypeName + "故障" + ".xlsx";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click(); //点击下载
                        URL.revokeObjectURL(elink); //释放掉blob对象
                        document.body.removeChild(elink); //下载完成移除元素
                    }
                })
                .catch((err) => {
                    this.$notify.error({
                        title: "提示",
                        message: err.message,
                    });
                });
        },
    }
}
</script>

<style>
.operation_list {
    margin-top: 30px;
    width: 100%;
    height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/home_page/faultType/homeFaultCar.vue